import { createActionThunk } from 'redux-thunk-actions'
import { handleActions } from 'redux-actions'
import { actions as toastr } from 'react-redux-toastr'
import _ from 'lodash'

import api from 'core/api'

const getType = type => `@deposits/payment_addresses/${type}`

export const getPaymentAddresses = createActionThunk(
  getType('FETCH'),
  api('/deposits/payment_addresses')
)
export const getPaymentAddressByCurrencyThunk = createActionThunk(
  getType('FETCH_BY_CURRENCY'),
  (currency, ...rest) => {
    return api(`/deposits/payment_addresses`, { method: 'POST' })({ currency }, ...rest)
  }
)

export const getPaymentAddressByCurrency = props => dispatch =>
  dispatch(getPaymentAddressByCurrencyThunk(props)).catch(res => {
    if (_.has(res, 'error.error.details') && _.isString(res.error.error.details))
      dispatch(toastr.add({ type: 'error', message: res.error.error.details }))
    if (_.has(res, 'error.error.type') && res.error.error.type === 'validation_error')
      dispatch(toastr.add({ type: 'error', message: 'Validation error' }))
  })

const initialState = {}

export default handleActions(
  {
    [getPaymentAddresses.SUCCEEDED]: (state, { payload }) => ({ ...state, ...payload }),
    [getPaymentAddresses.FAILED]: (state, { payload }) => ({ ...state, ...payload }),
    [getPaymentAddressByCurrencyThunk.SUCCEEDED]: (state, { payload }) => ({
      ...state,
      json: {
        ...state.json,
        ...payload.json
      }
    }),
    [getPaymentAddressByCurrencyThunk.FAILED]: (state, { payload }) => ({ ...state, ...payload })
  },
  initialState
)



// WEBPACK FOOTER //
// ./src/modules/deposits/payment_addresses.js